import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { EntryTemplate } from '../../components/Templates/Auth/EntryTemplate';
import {
  getWebPageLink,
  WebPageLink,
  WebPageType,
} from '../../constants/webPageType';
import useRedirectHome from '../../hooks/useRedirectHome';
import useRegisterQuery from '../../hooks/useRegisterQuery';
import { useSessionStore } from '../../stores/SessionStore';

interface EntryScreenProps {
  webPageType: WebPageType;
}

const EntryScreen: React.FC<EntryScreenProps> = ({ webPageType }) => {
  const navigate = useNavigate();
  const { query } = useRegisterQuery();
  const isLoggedIn = useSessionStore((state) => state.isLoggedIn);

  useRedirectHome(isLoggedIn(), webPageType);

  const onClickTryNow = useCallback(() => {
    navigate('/trial' + query);
  }, [navigate, query]);

  const onClickLogin = useCallback(() => {
    navigate(getWebPageLink(webPageType, WebPageLink.Login) + query);
  }, [navigate, query, webPageType]);

  const onClickRegister = useCallback(() => {
    navigate(getWebPageLink(webPageType, WebPageLink.Register) + query);
  }, [navigate, query, webPageType]);

  return (
    <EntryTemplate
      webPageType={webPageType}
      onClickTryNow={onClickTryNow}
      onClickLogin={onClickLogin}
      onClickRegister={onClickRegister}
    />
  );
};
export default EntryScreen;
